/**
 * FormField — label wrapper for a form input, matching the app's compact
 * label style. Generic (no domain-specific content).
 *
 * Extracted from the Data Profiler feature, which had its own private copy.
 */
export function FormField({
  label,
  children,
}: {
  label: string;
  children: React.ReactNode;
}) {
  return (
    <label className="block">
      <span className="text-xs text-[var(--muted-foreground)] mb-1 block">
        {label}
      </span>
      {children}
    </label>
  );
}
